import styled from '@emotion/styled';
import { ThunderIcon } from '../Icons/ThunderIcon';
import { BreakpointsEnum } from '../../helpers/breakpoints';
import { Button } from '../Button/Button';

export const StyledCardContainer = styled.div`
    @media (max-width: ${BreakpointsEnum.sm}) {
        margin-bottom: 40px;
    }
`;

export const StyledCardTitle = styled.p`
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.gunmetal[100]};
    display: flex;
    align-items: center;
`;

export const StyledPhoneContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledPhone = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    color: ${({ theme }) => theme.colors.gunmetal[100]};
`;
export const StyledThunderIcon = styled(ThunderIcon)`
    fill: ${({ theme }) => theme.icon.brandColor1};
    margin-left: 4px;
`;

export const StyledImg = styled.img`
    border-radius: 50%;
    margin-right: 20px;
`;

export const StyledSchedule = styled.small`
    font-size: 12px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.gunmetal[70]};
`;

export const StyledButton = styled(Button)`
    margin-top: 24px;
    width: 100%;
`;

export const PhoneCardLegalText = styled.div<{ centerAlign: boolean }>`
    margin-top: 16px;
    text-align: left;
    font-size: 12px;
    color: ${({ theme }) => theme.text.color.primary2};
    text-align: ${({ centerAlign }) => (centerAlign ? 'center' : 'left')};
`;
